import { getLang } from "~/Utils/Utils";

export const getHeaders = () => {
  const token = sessionStorage.getItem("access_token");
  const lang = getLang();

  return {
    Authorization: token ? `Bearer ${token}` : "",
    ...(lang ? { "Accept-Language": lang } : {}),
  };
};